import { CalendarDays, Users } from 'lucide-react';

import styles from './CampSearchHero.module.css';

/*
 * Destination banner on the camp / stay search page.
 *
 * image comes from the backend (campingSearch -> heroImage): the
 * destination's saved image, else the first property's cover photo.
 * Without an image it shows a plain coloured banner.
 */

const fmt = (d) =>
    d ? new Date(d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : '';

const guestsText = (adults = 1, children = 0) =>
    [`${adults} Adult${adults > 1 ? 's' : ''}`, children ? `${children} Child${children > 1 ? 'ren' : ''}` : '']
        .filter(Boolean)
        .join(', ');

export default function CampSearchHero({ place, checkin, checkout, adults, children, image, total }) {
    const dates = checkin && checkout ? `${fmt(checkin)} - ${fmt(checkout)}` : '';
    const stays = total ? `${total} ${total === 1 ? 'stay' : 'stays'}` : 'stays';

    return (
        <>
            <header
                className={`${styles.hero} ${image ? styles.withImage : styles.compact}`}
                style={image ? { backgroundImage: `url("${image}")` } : undefined}
            >
                <div className={styles.content}>
                    <h1 className={styles.title}>{place}</h1>
                    <div className={styles.meta}>
                        {dates && (
                            <span>
                                <CalendarDays size={16} strokeWidth={1.8} /> {dates}
                            </span>
                        )}
                        <span>
                            <Users size={16} strokeWidth={1.8} /> {guestsText(adults, children)}
                        </span>
                    </div>
                    <p className={styles.subtitle}>
                        Explore {stays} in {place} for a peaceful getaway
                    </p>
                </div>
            </header>
            {total != null && (
                <p className={styles.found}>
                    {total} {total === 1 ? 'property' : 'properties'} found
                </p>
            )}
        </>
    );
}
